import React, { useState } from 'react'

import reactQuery from '../../_helpers/reactQuery'
import { notificationService } from '../../_services'
import translate from '../../locales/en'
import Document from '../Abstract/Document'

const Notifications = function () {
  const collectionName = 'Notifications'
  const singleCollectionName = 'Notification'
  const queryKey = collectionName.toLowerCase()
  const [body, setBody] = useState({})
  const defaultQueryParams = {}
  const [queryParams, setQueryParams] = useState(defaultQueryParams)
  const getQuery = reactQuery.getQuery(
    queryKey,
    queryParams,
    notificationService.query
  )
  const createMutation = reactQuery.createMutation(
    notificationService.create,
    singleCollectionName,
    queryKey
  )
  return (
    <Document
      tableActions={[
        {
          buttonLabel: `${translate.Add} ${translate[singleCollectionName]}`,
          buttonColor: 'primary',
          onSubmit: (args) => createMutation.mutate(args),
          body,
          setBody,
          withClear: true,
          clearFunction: () => setBody({}),
          form: {
            title: `${translate.Add} ${translate[singleCollectionName]}`,
            inputs: [
              {
                name: 'message',
                label: 'Message',
                type: 'text',
                required: true,
              },
              {
                name: 'messageAR',
                label: 'Arabic Message',
                type: 'text',
                required: true,
              },
            ],
          },
        },
      ]}
      title={collectionName}
      getQuery={getQuery}
      queryKey={queryKey}
      defaultQueryParams={defaultQueryParams}
      queryParams={queryParams}
      setQueryParams={setQueryParams}
      many
    />
  )
}
export default Notifications
